import React from 'react';
import Icon from '@pushpay/icon';

const PushPayLogoWithoutTextIcon = props => /*#__PURE__*/React.createElement(Icon, Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M12 0c6.63 0 12 5.37 12 12s-5.37 12-12 12S0 18.63 0 12 5.37 0 12 0Zm0 .831C5.835.831.831 5.828.831 12c0 6.172 5.004 11.169 11.169 11.169 6.165 0 11.169-4.997 11.169-11.169C23.169 5.828 18.165.831 12 .831Zm2.764 5.559c2.846 0 4.105 1.647 4.105 3.588 0 2.58-1.905 4.047-4.23 4.13l-.212.004h-2.172l-.652 3.491H9.678L11.85 6.39h2.914Zm-4.06 0L8.547 17.603h-.914L9.805 6.39h.9Zm-2.045 0L6.494 17.603h-.906L7.753 6.39h.906Zm6.195 1.722H13.43l-.84 4.285h1.686c1.453 0 2.667-.801 2.674-2.36 0-1.318-.951-1.925-2.097-1.925Z"
}));

export default PushPayLogoWithoutTextIcon;